module.exports = __webpack_public_path__ + "img/madeby.7d6a4205.svg";